"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ComponentWithBodyClass = _interopRequireDefault(require("../utils/ComponentWithBodyClass"));

var _setupStyledComponents = require("../listeners/setupStyledComponents");

var UIApplication =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIApplication, _React$Component);

  function UIApplication(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIApplication);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIApplication).call(this, props));
    (0, _setupStyledComponents.setupStyledComponents)();
    return _this;
  }

  (0, _createClass2.default)(UIApplication, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bodyClassName = _this$props.bodyClassName,
          className = _this$props.className,
          name = _this$props.name,
          TagName = _this$props.tagName,
          _bodyElement = _this$props._bodyElement,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["bodyClassName", "className", "name", "tagName", "_bodyElement"]);
      var classes = (0, _classnames.default)('ui-app', bodyClassName);
      return _react.default.createElement(_ComponentWithBodyClass.default, {
        bodyClassName: classes,
        bodyElement: _bodyElement
      }, _react.default.createElement(TagName, (0, _extends2.default)({
        className: (0, _classnames.default)('private-application', className),
        "data-application-name": name
      }, rest)));
    }
  }]);
  return UIApplication;
}(_react.default.Component);

UIApplication.propTypes = {
  _bodyElement: _propTypes.default.object,
  bodyClassName: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  tagName: _propTypes.default.string
};
UIApplication.defaultProps = {
  tagName: 'div'
};
UIApplication.displayName = 'UIApplication';
var _default = UIApplication;
exports.default = _default;
module.exports = exports.default;